export class ChatUserApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns ChatUserResponseDto Returns the current user
     * @throws ApiError
     */
    markMobileAppDownloaded({ requestBody, }) {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/chat-user/mark-mobile-app-downloaded',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
